import { render, staticRenderFns } from "./PhoneConfirm.vue?vue&type=template&id=2a7ba0d5&scoped=true&"
import script from "./PhoneConfirm.vue?vue&type=script&lang=js&"
export * from "./PhoneConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PhoneConfirm.vue?vue&type=style&index=0&id=2a7ba0d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ba0d5",
  null
  
)

export default component.exports